var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tagName,{ref:"download",tag:"component",on:{"click":function($event){return _vm.handleDownload()}}},[(_vm.title === '')?[_vm._t("default")]:_vm._e(),[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]],2)}
var staticRenderFns = []

export { render, staticRenderFns }